import { useMutation } from "@tanstack/react-query"

import { invalidateSessionMedia } from "../invalidateSessionMedia"
import { trpcOptions } from "../trpc"

export function useUpsertPhoto(sessionId: string) {
  return useMutation(
    trpcOptions.app.upsertPhoto.mutationOptions({ onSuccess: () => invalidateSessionMedia(sessionId) }),
  )
}
